var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isEqual } from "lodash";
import { usePublisherQuery } from "../../../hooks/usePublisherQuery";
var DEFAULT_STATUS = ["ACTIVE"];
var DEFAULT_FILTERS = {
    search: "",
    name: "",
    companyNumber: "",
    startDate: undefined,
    endDate: undefined,
    status: DEFAULT_STATUS,
};
var parseFiltersFromSearch = function (search) {
    if (search === "") {
        return DEFAULT_FILTERS;
    }
    var queryParams = new URLSearchParams(search);
    return {
        search: queryParams.get("search") || "",
        name: queryParams.get("name") || "",
        companyNumber: queryParams.get("companyNumber") || "",
        startDate: queryParams.get("startDate") || undefined,
        endDate: queryParams.get("endDate") || undefined,
        status: queryParams.has("status")
            ? queryParams.getAll("status")
            : [],
    };
};
export var usePublisherFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var isFirstLoad = useRef(true);
    var _a = useState(function () {
        return parseFiltersFromSearch(location.search);
    }), filters = _a[0], setFilters = _a[1];
    var _b = useState(function () {
        return parseFiltersFromSearch(location.search);
    }), draftFilters = _b[0], setDraftFilters = _b[1];
    var _c = useState(0), pageOffset = _c[0], setPageOffset = _c[1];
    var _d = useState(true), filterPaneIsVisible = _d[0], setFilterPaneIsVisible = _d[1];
    var detailId = new URLSearchParams(location.search).get("detail");
    var selectedPublisher = usePublisherQuery(detailId).data;
    useEffect(function () {
        if (isFirstLoad.current && location.search === "") {
            isFirstLoad.current = false;
            var params = new URLSearchParams();
            params.set("status", "ACTIVE");
            history.replace({ search: params.toString() });
            return;
        }
        isFirstLoad.current = false;
        var parsed = parseFiltersFromSearch(location.search);
        setFilters(function (prev) { return (isEqual(prev, parsed) ? prev : parsed); });
        setDraftFilters(function (prev) { return (isEqual(prev, parsed) ? prev : parsed); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);
    var updateDraftFilter = function (key, value) {
        setDraftFilters(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    var applyFilters = function () {
        setPageOffset(0);
        setFilters(draftFilters);
        var params = new URLSearchParams();
        if (draftFilters.search)
            params.set("search", draftFilters.search);
        if (draftFilters.name)
            params.set("name", draftFilters.name);
        if (draftFilters.companyNumber)
            params.set("companyNumber", draftFilters.companyNumber);
        if (draftFilters.startDate)
            params.set("startDate", draftFilters.startDate);
        if (draftFilters.endDate)
            params.set("endDate", draftFilters.endDate);
        draftFilters.status.forEach(function (s) { return params.append("status", s); });
        history.push({ search: params.toString() });
    };
    var handleStatusChange = function (status) {
        setDraftFilters(function (prev) { return (__assign(__assign({}, prev), { status: prev.status.includes(status)
                ? prev.status.filter(function (s) { return s !== status; })
                : __spreadArray(__spreadArray([], prev.status, true), [status], false) })); });
    };
    var clearFilters = function () {
        setPageOffset(0);
        setDraftFilters(DEFAULT_FILTERS);
        setFilters(DEFAULT_FILTERS);
        history.push({ search: "?status=ACTIVE" });
    };
    var hasDefaultFilters = function () { return isEqual(filters, DEFAULT_FILTERS); };
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var closeDetail = function () {
        var queryParams = new URLSearchParams(location.search);
        queryParams.delete("detail");
        history.replace({ search: queryParams.toString() });
    };
    var openDetail = function (item) {
        var currentParams = new URLSearchParams(location.search);
        currentParams.delete("detail");
        history.push({
            search: "".concat(currentParams.toString(), "&detail=").concat(item.id),
        });
    };
    return {
        filters: filters,
        draftFilters: draftFilters,
        updateDraftFilter: updateDraftFilter,
        applyFilters: applyFilters,
        handleStatusChange: handleStatusChange,
        clearFilters: clearFilters,
        hasDefaultFilters: hasDefaultFilters,
        pageOffset: pageOffset,
        setPageOffset: setPageOffset,
        filterPaneIsVisible: filterPaneIsVisible,
        toggleFilterPane: toggleFilterPane,
        selectedPublisher: selectedPublisher !== null && selectedPublisher !== void 0 ? selectedPublisher : null,
        closeDetail: closeDetail,
        openDetail: openDetail,
    };
};
